module.exports = __webpack_public_path__ + "img/About_fw_2.4f738aaf.png";